// src/App.js
// Tela principal com menu de 4 opções do CRUD

import React, { useState } from "react";
import Consultar from "./components/Consultar";
import Inserir from "./components/Inserir";
import Alterar from "./components/Alterar";
import Alterar2 from "./components/Alterar2";
import Apagar from "./components/Apagar";
import "./App.css";

// Definição das opções do menu
const MENU_OPCOES = [
  { id: "consultar", label: "Consultar",  icon: "🔍", desc: "Listar e buscar produtos" },
  { id: "inserir",   label: "Inserir",    icon: "➕", desc: "Adicionar novo produto"  },
  { id: "alterar",   label: "Alterar",    icon: "✏️",  desc: "Editar produto existente"},
  { id: "apagar",    label: "Apagar",     icon: "🗑️",  desc: "Remover produto"        },
  { id: "alterar2",  label: "Alterar2",    icon: "✏️",  desc: "Editar produto existente2"},
];

export default function App() {
  // Estado que controla qual tela está ativa (null = tela inicial)
  const [telaAtiva, setTelaAtiva] = useState(null);

  // Renderiza o componente correspondente à opção selecionada
  const renderizarTela = () => {
    switch (telaAtiva) {
      case "consultar": return <Consultar onVoltar={() => setTelaAtiva(null)} />;
      case "inserir":   return <Inserir   onVoltar={() => setTelaAtiva(null)} />;
      case "alterar":   return <Alterar   onVoltar={() => setTelaAtiva(null)} />;
      case "apagar":    return <Apagar    onVoltar={() => setTelaAtiva(null)} />;
      case "alterar2":  return <Alterar2  onVoltar={() => setTelaAtiva(null)} />;
      default:          return null;
    }
  };

  const voltarPos = () => {
    switch (telaAtiva) {
      case "consultar": return 0;
      case "inserir":   return 1;
      case "alterar":   return 2;
      case "apagar":    return 3;
      case "alterar2":  return 4;
      default:          return null;
    }
  };
  

  return (
    <div className="app">
      <header className="app-header">
        <div className="logo">
          <span className="logo-icon">📦</span>
          <div>
            <h1>Gestão de Produtos</h1>
            <p>Tutorial ReactJS — CRUD Completo</p>
          </div>
        </div>
        {telaAtiva && (
          <button className="btn-voltar" onClick={() => setTelaAtiva(null)}>
            ← Menu Principal
          </button>
        )}
      </header>

      <main className="app-main">
        {/* Tela inicial: exibe o menu de 4 opções */}
        {!telaAtiva ? (
          <div className="menu-container">
            <div className="menu-titulo">
              <h2>O que deseja fazer?</h2>
              <p>Selecione uma das operações abaixo</p>
            </div>
            <div className="menu-grid">
              {MENU_OPCOES.map((opcao) => (
                <button
                  key={opcao.id}
                  className={`menu-card menu-card--${opcao.id}`}
                  onClick={() => setTelaAtiva(opcao.id)}
                >
                  <span className="menu-card__icon">{opcao.icon}</span>
                  <span className="menu-card__label">{opcao.label}</span>
                  <span className="menu-card__desc">{opcao.desc}</span>
                </button>
              ))}
            </div>
          </div>
        ) : (
          <div className="menu-container">
             <div className="tela-header">
               <h2>✏️ {MENU_OPCOES[voltarPos(telaAtiva)].desc}</h2>
              
              <button className="btn-voltar" onClick={() => setTelaAtiva(null)}>
                ← Menu Principal
              </button>
            </div>
                    
            <div className="tela-container">{renderizarTela()}</div>
          </div>
        )}
      </main>
    </div>
  );
}
